import quickFetch from 'quick-fetch';

interface QuickFetchOptions<T> {
  makeRequestFn: () => Promise<T>;
  /**
   * Optionally remove the response after fetching.
   * Default to remove response from quick-fetch if value is "undefined"
   */
  removeAfterFetch?: boolean;
  requestName?: string;
}

export function makeQuickFetchRequest<T>(options: QuickFetchOptions<T>) {
  const { makeRequestFn, removeAfterFetch, requestName } = options;

  if (!requestName) {
    return makeRequestFn();
  }

  const earlyRequest = quickFetch.getRequestStateByName(requestName);

  if (!earlyRequest) {
    return makeRequestFn();
  }

  const resultPromise: Promise<T> = new Promise((resolve, reject) => {
    earlyRequest.whenFinished((result: T) => {
      resolve(result);
      if (removeAfterFetch === undefined || removeAfterFetch) {
        quickFetch.removeEarlyRequest(requestName);
      }
    });
    earlyRequest.onError(() => {
      makeRequestFn()
        .then(resolve, reject)
        .catch(() => {
          // Eslint catch statement
        });
      if (removeAfterFetch === undefined || removeAfterFetch) {
        quickFetch.removeEarlyRequest(requestName);
      }
    });
  });

  return resultPromise;
}
